export interface PatientInformationDailyInsightsQuery {
    patientId: number;
    insightQueryEndDate: string;
}

export enum InsightImageStatus {
    LOADING,
    READY,
    ERROR
}
export interface CachedInsightImage {
    readonly url: string;
    status: InsightImageStatus;
    date: string;
    blobUrl: string | undefined;
}

export interface PatientInformationDailyInsightsActions {
    navigateToNext:() => void;
    navigateToPrevious:() => void;
    navigateToLatest:() => void;
    reloadInsightFigure:() => void;
}
export interface PatientInformationDailyInsightsOwnProps {
    dailyInsightState: PatientInformationDailyInsightsMappedState;
    patientId?: number;
}

export interface PatientInformationDailyInsightsProps {}

export interface PatientInformationDailyInsightsMeta extends PatientInformationDailyInsightsOwnProps, PatientInformationDailyInsightsProps, PatientInformationDailyInsightsActions {

}

export interface PatientInformationDailyInsightsState extends PatientInformationDailyInsightsMappedState, PatientInformationDailyInsightsUnmappedState {

}

export interface PatientInformationDailyInsightsMappedState{
    currentImageIndex: number;
    currentImage: CachedInsightImage | undefined;
    loading: boolean;
    refreshing: boolean;
    error: any;
    hasPrevious: boolean;
    hasNext: boolean;
    initialized: boolean;
}

export interface PatientInformationDailyInsightsUnmappedState {
    loadedImages: CachedInsightImage[];
    additionalInsightsAvailable: boolean;
}